import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

const Header = ({ title }) => {
  const [t] = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {title ? `${t('Dashboard.Property.Text')}: ${title}` : t('Dashboard.Property.Text')}
    </Typography>
  );
};

Header.propTypes = {
  title: PropTypes.string
};

export default React.memo(Header);
